import { SVGProps } from 'react';

const Recycle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.79 1.79 0 0 1-.004-1.784L7.196 9.5M3.1 10.598 7.196 9.5l1.097 4.096M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.78 1.78 0 0 0 0-1.775l-1.226-2.12M14 22l-3-3 3-3M9.344 5.811l1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.78 1.78 0 0 1 1.546.888l3.943 6.843m1.097-4.096-1.097 4.096-4.096-1.098"
    />
  </svg>
);
export default Recycle;
